import { useMemo } from 'react'
import { useLocation } from 'react-router'
// import qs from 'qs'
export function useUrlSearch<T extends Record<string, any>>() {
  const location = useLocation()
  const params = useMemo(() => {
    const search = location.search.indexOf('?') > -1 ? location.search.slice(1) : location.search
    if (!search) {
      return {}
    }
    const parseResult = search.split('&').reduce((result, it) => {
      const [key, value] = it.split('=')

      return Object.assign(result, {
        [key]: value?.trim() ? decodeURIComponent(value.trim()) : undefined,
      })
    }, {})

    return parseResult
    // return qs.parse(search) // 会忽略特殊字符，如skuId=A0025-.*+/%_解析后，"+"丢掉了
  }, [location.search])

  return params as T
}
